export const userErrors = `
userErrors {
    code
    field
    message
}
`;
